<template>
	<div v-if="model.$dirty">
		<div class="m-error" v-if="model.required == false">{{ label }} é obrigatório.</div>
		<div class="m-error" v-if="model.minLength == false">Mínimo de {{ model.$params.minLength.min }} caracteres.</div>
		<div class="m-error" v-if="model.maxLength == false">Máximo de {{ model.$params.maxLength.min }} caracteres.</div>
		<div class="m-error" v-if="model.between == false">Deve ser entre {{model.$params.between.min}} e {{model.$params.between.max}}</div>
	</div>
</template>

<script>
	export default {
		props: ["label", "model"]
	};
</script>